import { render, staticRenderFns } from "./ProductionprogressPage.vue?vue&type=template&id=e2b3ae3e"
import script from "./ProductionprogressPage.vue?vue&type=script&lang=js"
export * from "./ProductionprogressPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports